<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router/composables'
import { getAuthServiceConfig } from '@/auth-service'

defineProps<{
  type: 'login' | 'register'
}>()

const emit = defineEmits(['complete'])

const { endpoint, token, setToken, type: tokenType } = getAuthServiceConfig()
const returnUrl = window.location.href
const tenant = window.injectedEnv.FRONTEND_TENANT

const route = useRoute()

if (route.query.token) {
  const resolvedTokenType = route.query.tokenType === 'auth_prospect' ? 'auth-prospect' : 'auth'
  setToken(route.query.token as string, resolvedTokenType)
  emit('complete')
}

const app = getCurrentInstance()!

const helpText = computed(() => app.proxy.$configurations.authServiceHelpText)

const prospectToken = computed(() => tokenType === 'auth-prospect' ? token : undefined)
</script>

<template>
  <div class="auth-service-login">
    <ignite-auth-service-login-buttons
      id="auth-service-login-buttons"
      :endpoint="endpoint"
      :return-url="returnUrl"
      :prospect-token="prospectToken"
      :type="type"
      :tenant="tenant"
    />

    <ignite-auth-service-forgot-button
      v-if="type === 'login'"
      :endpoint="endpoint"
      :return-url="returnUrl"
    />

    <template v-if="type === 'login'">
      <p class="double-top-margin">
        If you have not yet registered your account, please follow the steps below
      </p>

      <ignite-auth-service-register-button
        :endpoint="endpoint"
        :return-url="returnUrl"
        :tenant="tenant"
      />
    </template>

    <p v-if="helpText">
      {{ helpText }}
    </p>
  </div>
</template>

<style lang="css" scoped>
.auth-service-login {
  margin: auto;
}

.auth-service-login {
  text-align: center;
  row-gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: center
}

.double-top-margin {
  margin-top: 32px;
}
</style>
